/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ContactDetailsFilter } from './ContactDetailsFilter';
import {
    ContactDetailsFilterFromJSON,
    ContactDetailsFilterFromJSONTyped,
    ContactDetailsFilterToJSON,
} from './ContactDetailsFilter';

/**
 * 
 * @export
 * @interface ListContactsByFiltersRequestContent
 */
export interface ListContactsByFiltersRequestContent {
    /**
     * 
     * @type {string}
     * @memberof ListContactsByFiltersRequestContent
     */
    contactImportId?: string;
    /**
     * 
     * @type {string}
     * @memberof ListContactsByFiltersRequestContent
     */
    from?: string;
    /**
     * 
     * @type {string}
     * @memberof ListContactsByFiltersRequestContent
     */
    to?: string;
    /**
     * 
     * @type {Array<ContactDetailsFilter>}
     * @memberof ListContactsByFiltersRequestContent
     */
    filters?: Array<ContactDetailsFilter>;
    /**
     * 
     * @type {number}
     * @memberof ListContactsByFiltersRequestContent
     */
    limit?: number;
    /**
     * 
     * @type {number}
     * @memberof ListContactsByFiltersRequestContent
     */
    pageIndex?: number;
    /**
     * 
     * @type {number}
     * @memberof ListContactsByFiltersRequestContent
     */
    totalPages?: number;
    /**
     * 
     * @type {number}
     * @memberof ListContactsByFiltersRequestContent
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof ListContactsByFiltersRequestContent
     */
    totalFailedContacts?: number;
    /**
     * 
     * @type {number}
     * @memberof ListContactsByFiltersRequestContent
     */
    totalCompletedContacts?: number;
}


/**
 * Check if a given object implements the ListContactsByFiltersRequestContent interface.
 */
export function instanceOfListContactsByFiltersRequestContent(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ListContactsByFiltersRequestContentFromJSON(json: any): ListContactsByFiltersRequestContent {
    return ListContactsByFiltersRequestContentFromJSONTyped(json, false);
}

export function ListContactsByFiltersRequestContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListContactsByFiltersRequestContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'contactImportId': !exists(json, 'contactImportId') ? undefined : json['contactImportId'],
        'from': !exists(json, 'from') ? undefined : json['from'],
        'to': !exists(json, 'to') ? undefined : json['to'],
        'filters': !exists(json, 'filters') ? undefined : ((json['filters'] as Array<any>).map(ContactDetailsFilterFromJSON)),
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
        'pageIndex': !exists(json, 'pageIndex') ? undefined : json['pageIndex'],
        'totalPages': !exists(json, 'totalPages') ? undefined : json['totalPages'],
        'totalRecords': !exists(json, 'totalRecords') ? undefined : json['totalRecords'],
        'totalFailedContacts': !exists(json, 'totalFailedContacts') ? undefined : json['totalFailedContacts'],
        'totalCompletedContacts': !exists(json, 'totalCompletedContacts') ? undefined : json['totalCompletedContacts'],
    };
}

export function ListContactsByFiltersRequestContentToJSON(value?: ListContactsByFiltersRequestContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'contactImportId': value.contactImportId,
        'from': value.from,
        'to': value.to,
        'filters': value.filters === undefined ? undefined : ((value.filters as Array<any>).map(ContactDetailsFilterToJSON)),
        'limit': value.limit,
        'pageIndex': value.pageIndex,
        'totalPages': value.totalPages,
        'totalRecords': value.totalRecords,
        'totalFailedContacts': value.totalFailedContacts,
        'totalCompletedContacts': value.totalCompletedContacts,
    };
}

